import { AriaRole, ReactNode } from "react";
import cx from "classnames";

import Typography, { TypographyProps } from "ds/components/Typography";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";
import CollapsibleSectionToggle, { CollapsibleSectionToggleProps } from "./Toggle";

type CollapsibleSectionHeaderProps = {
  suffix?: ReactNode;
  titleSuffix?: ReactNode;
  titleHtmlFor?: string;
  titleTag?: TypographyProps["tag"];
  titleVariant?: TypographyProps["variant"];
  children: ReactNode;
  className?: string;
  align?: BoxProps["align"];
  role?: AriaRole;
} & CollapsibleSectionToggleProps;

const CollapsibleSectionHeader = ({
  suffix,
  titleSuffix,
  children,
  titleHtmlFor,
  titleTag = "span",
  titleVariant,
  className,
  align = "center",
  role,
  ...collapsibleSectionToggleProps
}: CollapsibleSectionHeaderProps) => {
  return (
    <Box justify="between" align="center" className={cx(styles.header, className)} role={role}>
      <Box grow="1" align={align} className={styles.titleWrapper}>
        <CollapsibleSectionToggle {...collapsibleSectionToggleProps} />
        {typeof children === "string" ? (
          <Typography
            className={styles.title}
            variant={titleVariant}
            tag={titleTag}
            htmlFor={titleHtmlFor}
          >
            {children}
          </Typography>
        ) : (
          children
        )}
        {titleSuffix}
      </Box>
      {suffix}
    </Box>
  );
};

CollapsibleSectionHeader.displayName = "DS.CollapsibleSection.Header";

export default CollapsibleSectionHeader;
